<template>
  <div id="wrap" class="install ko">
    <header class="p_header">
      <section class="p_title">
        <!-- <div class="p_left">
          <p>
            <span class="font_color_yellow">KOLON Mail</span>
            <span class="font_regular">앱</span></p>
          <p>200% 활용 꿀팁</p>
        </div>
        <div class="p_right">
          <img src="@/assets/image/tip/icn-mail.png">
        </div> -->
      </section><!-- //p_title -->
    </header>
    <article class="tip_container">
      <section class="section_tip1">
        <div class="section_comment">
          <p>
            확 바뀐 IKEN App!
          </p>
          <p>
            더 잘 쓰게 만들어주는 꿀팁 대방출합니다.
          </p>
        </div>
        <div class="tip_title">
          <div class="tip_title_left">
            <p class="tip_title_order">
              하나
            </p>
          </div>
          <div class="tip_title_right">
            <p class="tip_title_top">
              알아서 내가 자주 쓰는 서비스를 알려주네
            </p>
            <p class="title_main">
              자동 추천 기능을 켜볼까?
            </p>
          </div>
        </div>
        <div class="tip_contents">
          <p>
            내가 굳이 편집하지 않아도
          </p>
          <p>
            자주 사용했던 서비스 순서대로 보여요!
          </p>
          <p>
            빠르게 내가 자주 쓰는 서비스로 이동하기 좋겠죠?
          </p>
        </div>
        <div class="tip_info">
          <div class="tip_flow">
            <p>자동추천 &gt; 켜기</p>
          </div>
          <div class="gradient">
          </div>
          <div class="tip_img">
            <img class="img_phone" src="@/assets/image/tip/phone-tip-01.png">
            <img class="img_detail" src="@/assets/image/tip/main-3-x.png">
          </div>
        </div>
      </section>

      <section class="section_tip2">
        <div class="tip_title">
          <div class="tip_title_left">
            <p class="tip_title_order">
              둘
            </p>
          </div>
          <div class="tip_title_right">
            <p class="tip_title_top">
              내가 보고싶었던 정보가 다 모여 있네
            </p>
            <p class="title_main">
              My를 메인 화면으로 바꿔 볼까?
            </p>
          </div>
        </div>
        <div class="tip_contents">
          <p>
            일정, 연차, 팀원근무현황, 구내식당이용정보
          </p>
          <p>
            날씨, 대중교통 도착정보, 추천맛집 정보까지
          </p>
          <p>
            앱을 켰을 때 바로 보고 싶으시다면 메인 화면으로 설정하세요!
          </p>
        </div>
        <div class="tip_info">
          <div class="tip_flow">
            <p>My를 메인으로 &gt; 켜기</p>
          </div>
          <div class="gradient">
          </div>
          <div class="tip_img">
            <img class="img_phone" src="@/assets/image/tip/phone-01-copy-7.png">
            <img class="img_detail" src="@/assets/image/tip/my-00-3-x.png">
          </div>
        </div>
      </section>

      <section class="section_tip3">
        <div class="tip_title">
          <div class="tip_title_left">
            <p class="tip_title_order">
              셋
            </p>
          </div>
          <div class="tip_title_right">
            <p class="tip_title_top">
              모바일로 바로 등록이 필요할 때
            </p>
            <p class="title_main">
              등록 기능 바로 이동하기
            </p>
          </div>
        </div>
        <div class="tip_contents">
          <p>
            자원예약, 서비스 요청, 보안서비스 신청, 방문객예약
          </p>
          <p>
            +버튼을 누르면 바로 이동 가능해요~
          </p>
        </div>
        <div class="tip_info">
          <div class="tip_flow">
            <p>Work/News/My탭 &gt; +버튼 선택</p>
          </div>
          <div class="gradient">
          </div>
          <div class="tip_img">
            <img class="img_phone" src="@/assets/image/tip/phone-01-copy-10.png">
            <!-- <img class="img_detail" src="@/assets/image/tip/my-00-3-x.png"> -->
          </div>
        </div>
      </section>

      <section class="section_tip4">
        <div class="tip_title">
          <div class="tip_title_left">
            <p class="tip_title_order">
              넷
            </p>
          </div>
          <div class="tip_title_right">
            <p class="tip_title_top">
              내가 관심있는 글만 쏙쏙
            </p>
            <p class="title_main">
              관심 키워드 등록 하기
            </p>
          </div>
        </div>
        <div class="tip_contents">
          <p>
            평소에 관심있는 소식이 있나요?
          </p>
          <p>
            키워드를 등록해두면 키워드가 포함된 글이 등록되면
          </p>
          <p>
            따로 모아 볼 수 있어요!
          </p>
        </div>
        <div class="tip_info">
          <div class="tip_flow">
            <p>등록(<img src="@/assets/image/tip/icon-outlined-24-lg-1-menu-copy-4.png">)선택</p>
          </div>
          <div class="gradient">
          </div>
          <div class="tip_img">
            <img class="img_phone" src="@/assets/image/tip/phone-01-copy-8.png">
            <img class="img_detail" src="@/assets/image/tip/my-09-3-x.png">
          </div>
        </div>
      </section>

      <section class="section_tip5">
        <div class="tip_title">
          <div class="tip_title_left">
            <p class="tip_title_order">
              다섯
            </p>
          </div>
          <div class="tip_title_right">
            <p class="tip_title_top">
              다양해진 알림 서비스
            </p>
            <p class="title_main">
              날씨 알림, 구내식당 메뉴 알림
            </p>
          </div>
        </div>
        <div class="tip_contents">
          <p>
            비/눈 오는 날은 우산 잊지 않도록 날씨 알림 서비스
          </p>
          <p>
            오늘의 구내식당 점심 메뉴를 알림으로 받아볼 수 있어요!
          </p>
        </div>
        <div class="tip_info">
          <div class="tip_flow">
            <p>1)날씨 알림 &gt; 켜기</p>
            <p>2)구내식당 메뉴 알림 &gt; 켜기</p>
          </div>
          <div class="gradient">
          </div>
          <div class="tip_img">
            <img class="img_phone" src="@/assets/image/tip/phone-01-copy-9.png">
            <!-- <img class="img_detail" src="@/assets/image/tip/my-09-3-x.png"> -->
          </div>
        </div>
      </section>
    </article>
  </div>
</template>

<style scoped>
@import "../assets/css/tip.css";
</style>

<script>

export default {
  name: 'Tips',
  components: {
  },
  data(){
    return {
    }
  },
  computed: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Tips.vue